<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 13.5C0.895431 13.5 0 12.6046 0 11.5V7.5H16V11.5C16 12.6046 15.1046 13.5 14 13.5L2 13.5ZM16 5.5H0V4.5C0 3.39543 0.89543 2.5 2 2.5H14C15.1046 2.5 16 3.39543 16 4.5V5.5ZM14 9.5H11V11.5H14V9.5Z"
  />
</template>
